import { BackgroundImage, Content, Headline, HeroBannerContainer, TextContainer, DownArrowButtonContainer, ButtonContainer } from "./styles";
import DownArrowButton from '../Buttons/DownArrowButton/DownArrowButton';

interface HeroBannerProps {
  imageSource: string;
  headline: string;
  text: string;
  onNextSection?: () => void;
  primaryButton?: React.ReactNode;  
  secondaryButton?: React.ReactNode;
}

const HeroBanner = ({ imageSource, headline, text, onNextSection, primaryButton, secondaryButton }: HeroBannerProps) => {
  const hasButtonContainer = !!primaryButton && !!secondaryButton;

  return (
    <HeroBannerContainer>
      <BackgroundImage imageUrl={imageSource} />
      <TextContainer>
        <Headline lang="de">{headline}</Headline>
        <Content>{text}</Content>
      </TextContainer>
      {hasButtonContainer && (
        <ButtonContainer>
          {primaryButton}
          {secondaryButton}
        </ButtonContainer>
      )}
      {onNextSection && (
        <DownArrowButtonContainer hasButtonContainer={hasButtonContainer}>
          <DownArrowButton onClick={onNextSection} />
        </DownArrowButtonContainer>
      )}
    </HeroBannerContainer>
  );
};

export default HeroBanner;
